import React from "react";
import Image from "../Tags/Image";
import "../../voice-assistant.css";

const VoiceAssistant = ({ state = "idle", className = "" }) => {
  const containerClassName = ["voice-assistant", className].filter(Boolean).join(" ");

  return (
    <div className={containerClassName}>
      <div className={`equalizer ${state !== "idle" && "active"}`}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      {/* <div className="voice-assistant__layer">
        {(state === "idle" || state === "mic") && (
          <div className={`icon listening ${state === "mic" ? "with-eq" : ""}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" />
              <path d="M19 11a7 7 0 0 1-14 0H3a9 9 0 0 0 18 0h-2z" />
            </svg>

            {state === "mic" && (
              <div className="equalizer">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            )}
          </div>
        )}

        {state === "speaker" && (
          <div className="icon speaking">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M5 9v6h4l5 5V4l-5 5H5z" />
              <path d="M15.5 12c0-1.77-1.02-3.29-2.5-4.03v8.06A4.992 4.992 0 0 0 15.5 12z" />
            </svg>

            <div className="equalizer">
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default VoiceAssistant;
